import React, { MouseEvent } from "react";
import { noop } from "lodash";
import { NullaryFn, UnaryFn } from "@tvg/ts-types/Functional";
import { DerbyEventStatus, HomepageEventBannerText } from "@fdr/types/ts/Derby";
import HomeHeaderLabel from "../../_molecules/HomeHeaderLabel";
import HomeHeaderHeadline from "../../_molecules/HomeHeaderHeadline";
import { Container, ButtonsWrapper } from "./styled-components";

interface Props {
  title?: HomepageEventBannerText;
  subtitle?: HomepageEventBannerText;
  description?: HomepageEventBannerText;
  raceStartDate?: Date | null;
  raceStatus: DerbyEventStatus;
  promoText?: string;
  forceFullDate?: boolean;
  raceNumber?: number;
  onHeaderClick: NullaryFn<void>;
  onPromoClick: UnaryFn<MouseEvent<HTMLDivElement>, void>;
}

const HomeHeaderBanner = ({
  title,
  subtitle,
  description,
  raceStartDate,
  raceStatus = DerbyEventStatus.POST,
  promoText,
  forceFullDate,
  raceNumber,
  onHeaderClick = noop,
  onPromoClick = noop
}: Props) => {
  const isRaceEnded = raceStatus === DerbyEventStatus.POST;
  return (
    <Container
      data-qa-label="homepage-header-banner"
      raceEnded={isRaceEnded}
      onClick={onHeaderClick}
    >
      <HomeHeaderHeadline
        title={title}
        subtitle={subtitle}
        description={description}
        raceStartDate={raceStartDate}
        raceStatus={raceStatus}
        forceFullDate={forceFullDate}
        raceNumber={raceNumber}
      >
        {!isRaceEnded && promoText && (
          <ButtonsWrapper data-qa-label="derby-labels" onClick={onPromoClick}>
            <HomeHeaderLabel
              derbyLabelType="promo"
              text={promoText}
              colorVariants={{ color: "yellow", value: "500" }}
              qaLabel="derbyNoSweatBetButton"
            />
          </ButtonsWrapper>
        )}
      </HomeHeaderHeadline>
    </Container>
  );
};

export default HomeHeaderBanner;
